<template>
  <a-modal
    :title="title"
    :width="1200"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="Close"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-table
          ref="table"
          rowKey="id"
          size="middle"
          :columns="columns"
          :dataSource="repayPlan"
          :scroll="{ x: 2300, y: 2000 }"
          :pagination="false"
          :loading="loading"
          bordered>
<!--          <Dict slot="loanStatus" slot-scope="text" :dict-code="DICT_CODE.LOAN_STATUS" :value="text"/>-->
<!--          <Dict slot="approvalStatus" slot-scope="text" :dict-code="DICT_CODE.ORDER_STATUS" :value="text"/>-->
<!--          <Dict slot="settleStatus" slot-scope="text" :dict-code="DICT_CODE.INSTALLMENT_SETTLE_STATUS" :value="text"/>-->
<!--          <Dict slot="overdueStatus" slot-scope="text" :dict-code="DICT_CODE.OVERDUE_STATUS" :value="text"/>-->
<!--          <span slot="action" slot-scope="text, record">-->

<!--          <a @click="handleLoan(record.id)" v-if='record.approvalStatus == 4'>-->
<!--            Loan-->
<!--          </a>-->
<!--          <a @click="handleOrderEdit(record)" v-if='record.approvalStatus != 4'>-->
<!--            Order edit-->
<!--          </a>-->
<!--          <a @click="handleEdit(record)" v-if='record.approvalStatus == 4'>-->
<!--            Edit repayment plan-->
<!--          </a>-->
<!--        </span>-->
          <span slot="action" slot-scope="text, record">
            <a-button @click="handleOfflineRepay(record)" style="margin-left: 8px;margin-bottom: 6px;" :disabled="record.status !=0">{{ $t('offlineRepay') }}</a-button>
            <a-button @click="handleDeduceLateFee(record)" style="margin-left: 8px;margin-bottom: 6px;" :disabled="record.status !=0">{{ $t('decLateFee') }}</a-button>
            <a-button v-if="repayPlan.length == 1"  @click="handleExtendRepay(record)" style="margin-left: 8px" :disabled="record.status !=0">{{ $t('extendRepay') }}</a-button>
        </span>
        </a-table>

      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>

import pick from 'lodash/pick'
import {installmentDeduceLateFee, installmentRepayOffline} from '@/webpublicapi/order'
import DictSelect from '../../modules/DictSelect';
import Dict from '@/views/webpublic/modules/Dict.vue'
import md5 from "md5";

const I18N_KEY = 'order.';
// duplicateCheck
export default {
  name: 'TestInstallOrderListModalPK',
  components: {
    Dict,
    DictSelect,
  },
  data () {
    return {
      value: 1,
      settleStatus: "",
      title: 'Action',
      visible: false,
      loading: false,
      columns: [
        {
          title:  this.$t(I18N_KEY + 'currentPeriod'),
          align: 'left',
          dataIndex: 'period',
        },
        {
          title: this.$t(I18N_KEY + 'status'),
          align: 'left',
          dataIndex: 'status'
        },
        {
          title: this.$t(I18N_KEY + 'overdueDays'),
          align: 'left',
          dataIndex: 'overdueDays'
        },
        {
          title: this.$t(I18N_KEY + 'startingTime'),
          align: 'left',
          dataIndex: 'beginDate',
        },
        {
          title: this.$t(I18N_KEY + 'expireTime'),
          align: 'left',
          dataIndex: 'endDate'
        },
        {
          title: this.$t(I18N_KEY + 'capital'),
          align: 'left',
          dataIndex: 'capital'
        },
        {
          title: this.$t(I18N_KEY + 'settledCapital'),
          align: 'left',
          dataIndex: 'settledCapital'
        },
        {
          title: this.$t(I18N_KEY + 'interest'),
          align: 'left',
          dataIndex: 'interest'
        },
        {
          title: this.$t(I18N_KEY + 'settledInterest'),
          align: 'left',
          dataIndex: 'settledInterest'
        },
        {
          title: this.$t(I18N_KEY + 'serviceFee'),
          align: 'left',
          dataIndex: 'serviceFee'
        },
        {
          title: this.$t(I18N_KEY + 'settledServiceFee'),
          align: 'left',
          dataIndex: 'settledServiceFee'
        },
        {
          title: this.$t(I18N_KEY + 'lateFee'),
          align: 'left',
          dataIndex: 'lateFee'
        },
        {
          title: this.$t(I18N_KEY + 'settledLateFee'),
          align: 'left',
          dataIndex: 'settledLateFee'
        },
        {
          title: this.$t(I18N_KEY + 'otherFee'),
          align: 'left',
          dataIndex: 'otherFee'
        },
        {
          title: this.$t(I18N_KEY + 'settledOtherFee'),
          align: 'left',
          dataIndex: 'settledOtherFee'
        },
        {
          title: this.$t(I18N_KEY + 'handleFee'),
          align: 'left',
          dataIndex: 'chargeFee'
        },
        {
          title: this.$t(I18N_KEY + 'settledHandleFee'),
          align: 'left',
          dataIndex: 'settledChargeFee'
        },
        {
          title: this.$t(I18N_KEY + 'couponAmount'),
          align: 'left',
          dataIndex: 'couponAmount'
        },
        {
          title: this.$t(I18N_KEY + 'deductionFee'),
          align: 'left',
          dataIndex: 'deductionFee'
        },
        {
          title: this.$t(I18N_KEY + 'usedDeductionFee'),
          align: 'left',
          dataIndex: 'usedDeductionFee'
        },
        {
          title: this.$t('action'),
          align: 'center',
          fixed: 'right',
          width: 150,
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      dataSource:[],
      repayPlan: [],
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      form: this.$form.createForm(this),
    }
  },
  created () {
  },
  methods: {
    checkBoxChange(checkedValue) {
      console.log(checkedValue)
    },
    add () {
      this.edit({})
    },
    handleExtendRepay(record){
      const self = this;
      this.$confirm({

        title: 'ConfirmExtensionRepayment?',
        content: h => {
          return (
            <div>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                <span style={{ marginRight: '10px' }}>Verify Password:</span>
                <input id='password' type='password' style={{ flex: '1' }} required/>
              </div>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <span style={{ marginRight: '10px' }}>Repayment Amount:</span>
                <input id='amount' type='number' style={{ flex: '1' }} />
              </div>
            </div>
          );
        },
        onOk() {
          self.loading = true;
          var password = document.getElementById("password").value;
          var amount = document.getElementById("amount").value;

          if(!password.trim()){
            alert('Verification password cannot be empty');
            self.loading = false;
            return false;
          }
          if (!amount.trim()) {
            alert('Repayment Amountcannot be empty');
            self.loading = false;
            return false;
          }
          var md5Password = md5(password);
          let extendFlag=1
          installmentRepayOffline({ repayPlanId: record.id, password: md5Password,extendFlag,amount }).then(res => {
            if(res.code===1000){
              // self.visible = false
              self.dealRefreshData(res.data)
              self.$parent.loadData()
            }else{
              self.$message.error(res.msg);
            }
            self.loading = false;
          }).catch(e => {
            self.loading = false;
            self.$message.error(e.message);
          })
        },
      });
    },
    handleOfflineRepay(record) {
      const self = this;
      this.$confirm({

        title: 'Confirm repayment online?',
        content: h => {
          return (
            <div>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                <span style={{ marginRight: '10px' }}>Verify Password:</span>
                <input id='password' type='password' style={{ flex: '1' }} required/>
              </div>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <span style={{ marginRight: '10px' }}>Repayment Amount:</span>
                <input id='amount' type='number' style={{ flex: '1' }} />
              </div>
            </div>
          );
        },
        onOk() {
          self.loading = true;
          var password = document.getElementById("password").value;
          var amount = document.getElementById("amount").value;

          if(!password.trim()){
            alert('Verification password cannot be empty');
            self.loading = false;
            return false;
          }
          if (!amount.trim()) {
            alert('Repayment Amountcannot be empty');
            self.loading = false;
            return false;
          }
          var md5Password = md5(password);

          installmentRepayOffline({ repayPlanId: record.id, password: md5Password, amount, }).then(res => {
            if(res.code===1000){
              // self.visible = false
              self.dealRefreshData(res.data)
              self.$parent.loadData()
            }else{
              self.$message.error(res.msg);
            }
            self.loading = false;
          }).catch(e => {
            self.loading = false;
            self.$message.error(e.message);
          })
        },
      });
    },

    handleDeduceLateFee(record) {
      const self = this;
      var latefees = record.lateFee;
      var interestss = record.interest;
      var deductionFeess = record.deductionFee;
      var overdueDaysss = record.overdueDays;
      this.$confirm({

        title: 'Confirm waive late fee?',
        content: h => {
          return (
            <div>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <span style={{ marginRight: '10px' }}>Late Fee(Overdue Fee):{latefees}</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <span style={{ marginRight: '10px' }}>Interest(Interest):{interestss}</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <span style={{ marginRight: '10px' }}>Interest+Late Fee(Interest+Overdue Fee):{interestss + latefees}</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <span style={{ marginRight: '10px' }}>Current Reduction Amount(Discount amount):{deductionFeess}</span>
              </div>
              <div style={{ display: 'flex', margin: '10px 0px 10px 0px', alignItems: 'center' }}>
                <span style={{ marginRight: '10px' }}>Reduction Amount(Modify discount amount):</span>
                <input id='deduceAmt' type='number' style={{ flex: '1' }} />
              </div>
              <div />
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <span style={{ marginRight: '10px' }}>Verify Password(Operation password):</span>
                <input id='password' type='password' style={{ flex: '1' }} required />
              </div>
            </div>
          );
        },
        onOk() {
          self.loading = true
          var deduceAmt = document.getElementById('deduceAmt').value

          var password = document.getElementById("password").value;

          // var maxdeFee = 0;
          // if(overdueDaysss > 0){
          //   maxdeFee = latefees + interestss;
          // } else {
          //   maxdeFee = latefees + interestss * 0.5;
          // }
          // console.log(maxdeFee);
          //
          // if(deduceAmt > maxdeFee){
          //   alert('Exceeds maximum reducible amount');
          //   self.loading = false;
          //   return false;
          // }
          if(!password.trim()){
            alert('Verification password cannot be empty');
            self.loading = false;
            return false;
          }
          if (!deduceAmt.trim()) {
            alert('Waiver amount cannot be empty')
            self.loading = false
            return false
          }

          var md5Password = md5(password);

          installmentDeduceLateFee({ planId: record.id, deduceAmt, password: md5Password,  latefees, overdueDaysss}).then(res => {
            if (res.code === 1000) {
              self.visible = false
              self.$message.success(res.msg);
              self.$parent.loadData()
            } else {
              self.$message.error(res.msg)
            }
            self.loading = false
          }).catch(e => {
            self.loading = false
            self.$message.error(e.message)
          })
        }
      });
    },
    dealRefreshData(data) {
      let index

      for (let i = 0; i < this.repayPlan.length; i++) {
        if (data.id === this.repayPlan[i].id) {
          index = i
          break
        }
      }

      this.repayPlan[index] = data
    },
    edit(record) {
      if (record.id) {
        this.visiblekey = true
      } else {
        this.visiblekey = false
      }
      this.form.resetFields()
      this.model = Object.assign({}, record)
      this.visible = true

      this.$nextTick(() => {
        this.repayPlan = record.repayPlans;
        this.model.approvalStatus=String(this.model.approvalStatus)
        this.model.loanStatus=String(this.model.loanStatus)
        // this.model.overdueStatus=String(this.model.overdueStatus)
        this.model.settleStatus=String(this.model.settleStatus)
        this.form.setFieldsValue(pick(this.model,  'approvalStatus', 'loanStatus','settleStatus','applyAmt','interest', 'deductionFee', 'orderPeriod'))
      })
    },
    // Confirm
    handleOk () {
      this.close()
      // const that = this
      // // Trigger form validation
      // this.form.validateFields((err, values) => {
      //   if (!err) {
      //     that.confirmLoading = true
      //     const formData = Object.assign(this.model, values)
      //     let obj
      //     console.log(formData)
      //     obj = editInstallmentOrderStatusForTest(formData)
      //     obj.then((res) => {
      //       if (res.code === 1000) {
      //         this.$message.success(res.msg)
      //         this.$emit('ok')
      //       } else {
      //         this.$message.warning(res.msg)
      //       }
      //     }).finally(() => {
      //       this.confirmLoading = false
      //       this.close()
      //     })
      //   }
      // })
    },
    // Close
    handleCancel () {
      this.close()
    },
    close () {
      this.$emit('close')
      this.visible = false
    }
  }
}
</script>
